import { render, staticRenderFns } from "./TableAdvances.vue?vue&type=template&id=2687b949&scoped=true"
import script from "./TableAdvances.vue?vue&type=script&lang=js"
export * from "./TableAdvances.vue?vue&type=script&lang=js"
import style0 from "./TableAdvances.vue?vue&type=style&index=0&id=2687b949&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2687b949",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/PurchaseOrderTracking/TableAdvances.vue
// module id = 2359
// module chunks = 31